import { useEffect } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import auth from './js/services/authentication';
import { StoreState } from './js/type.d';
import FeedbackModal from './js/components/FeedbackModal/FeedbackModal';
import SayThanksModal from './js/components/SayThanksModal/SayThanksModal';
import routes from './config/routes';
import PrivateRoute from './js/components/PrivateRoute/PrivateRoute';
import SubscriptionsStore from './js/xstores/subscriptions';
import useObservable from './js/hooks/useObservable';
import AppLoader from './js/components/AppLoader/AppLoader';
import CookieConsent from './js/components/CookieConsent/CookieConsent';
import queryString from 'query-string';

function App() {
  const { sessionState } = useSelector((rootReducer: StoreState) => rootReducer.reducer);
  const subscriptions = useObservable(SubscriptionsStore.current$, []);
  const subscriptionsLoading = useObservable(SubscriptionsStore.loading$, auth.isAuthenticated());

  useEffect(() => {
    const searchParams = queryString.parse(window.location.search);
    if (searchParams && searchParams.code) {
      return;
    }
    if (auth.isAuthenticated()) {
      SubscriptionsStore.getUserSubscriptions();
    }
  }, []);

  useEffect(() => {
    if (sessionState.err) {
      // @ts-ignore
      if (!sessionState.err.data?.success) {
        auth.clear();
        const privateRoutes = routes.filter(r => r.private).map(r => r.path);
        if (privateRoutes.indexOf(window.location.pathname) > -1) {
          window.location.assign('/');
        }
      }
    }
  }, [sessionState.err]);


  useEffect(() => {
    if (!auth.isAuthenticated() || window.location.pathname !== '/') {
      return;
    }
    if (!subscriptionsLoading && !subscriptions.length) {
      window.location.assign('/account');
    } else if (window.location.hash !== '#faqs') {
      window.location.assign('/searchportal')
    }
  }, [subscriptions, subscriptionsLoading]);
  if (auth.isAuthenticated() && subscriptionsLoading && window.location.pathname !== '/searchresults') {
    return <AppLoader />;
  }

  return (
    <Router>
      <Switch>
        {routes.map((route:any) =>
          route.private ?
            (
              <PrivateRoute key={route.path} path={route.path} exact={route.exact}>
                {route.children}
              </PrivateRoute>
            ) : (
              <Route key={route.path} path={route.path} exact={route.exact}>
                {route.children}
              </Route>
            )
        )}
        <Redirect from="*" to="/searchportal" />
      </Switch>
      <FeedbackModal />
      <SayThanksModal />
      <CookieConsent />
    </Router>
  );
}

export default App;
